// extracted by mini-css-extract-plugin
export var arrow = "_2z-6";
export var changeItem = "_2z-3";
export var changesHeader = "_2z-1";
export var changesList = "_2z-2";
export var container = "_2z-0";
export var pathLabel = "_2z-4";
export var value = "_2z-7";
export var valuesContainer = "_2z-5";